/* global window */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import './sliderVideo.scss'

export const OVERLAY_CLASS = 'overlay'
const VIDEO_CONTAINER_CLASS = 'video-container'

class SliderVideo extends Component {
  state = {
    play: false,
    inner: null,
  }

  componentDidMount() {
    window.addEventListener('mousedown', this.mouseDownHandler)

    setTimeout(() => {
      const { inner } = this.state
      $(inner).closest('.slick-track').find('.slick-slide:first-child .slide-content').removeClass(OVERLAY_CLASS);
      $(inner).closest('.slider-component').addClass('slider-component--video');
    }, 1000);
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.mouseDownHandler)
  }

  setInner = (elem) => {
    this.setState({ inner: elem })
  }

  mouseDownHandler = (e) => {
    e.stopPropagation()
    const { inner } = this.state

    if (inner
      && inner.childNodes
      && 'contains' in e.target // IE
      && e.target.contains(inner)
    ) {
      this.setState({ play: true })
    }

  }

  render() {
    const { video, title } = this.props
    return (
      <div className="iframe-container">
        <iframe
          ref={this.setInner}
          className={VIDEO_CONTAINER_CLASS}
          src={video}
          allowFullScreen
          title={title}
          allowvr="yes"
        />
      </div>
    )
  }
}

SliderVideo.propTypes = {
  video: PropTypes.string.isRequired,
  title: PropTypes.string,
}

SliderVideo.defaultProps = {
  title: '',
}

export default SliderVideo
